import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import {
  getAllAnnouncements,
  getAnnouncementById,
  getAnnouncementsByDocumentType,
} from '../../services/announcements.service';
import { AnnouncementDataModel } from 'src/types/propTypes/AnnouncementDataModel';

export const fetchAllAnnouncements = createAsyncThunk(
  'input/fetchAllAnnouncements',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      AnnouncementDataModel[]
    >(thunkAPI, getAllAnnouncements({ signal: thunkAPI.signal }));
  }
);

export const fetchAnnouncementById = createAsyncThunk(
  'input/fetchAnnouncementById',
  async (leaId: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<AnnouncementDataModel>(
      thunkAPI,
      getAnnouncementById(leaId, { signal: thunkAPI.signal })
    );
  }
);

export const fetchAnnouncementsByDocumentType = createAsyncThunk(
  'input/fetchAnnouncementsByDocumentType',
  async (documentType: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<AnnouncementDataModel[]>(
      thunkAPI,
      getAnnouncementsByDocumentType(documentType, { signal: thunkAPI.signal })
    );
  }
);